import { trpcVanilla } from "@client/trpc";
import {
  createSyncFeature,
  type StorageLike,
  type SyncFeature,
} from "@client/sync";
import { clipBookmarkKey, type ClipBookmarkRow } from "@lib/videoStateTypes";

export interface ClipBookmarkPayload {
  videoId: string;
  transcriptId: string;
  artifactType: "PROPOSAL_EXTRACTS" | "RECOMMENDER_EXTRACTS";
  clipKey: string;
  title: string;
  startSeconds: number;
  endSeconds: number;
  sourceContextId: string;
  bookmarked: boolean;
  clientUpdatedAt: string;
}

export interface ClipBookmarkFlushResult {
  applied: boolean;
  current: ClipBookmarkRow | null;
}

export function createClipBookmarkSync(args: {
  onSuccess: (
    result: ClipBookmarkFlushResult,
    payload: ClipBookmarkPayload,
  ) => void;
  storage?: StorageLike;
  shouldCommit?: () => boolean;
}): SyncFeature<ClipBookmarkPayload> {
  return createSyncFeature<ClipBookmarkPayload, ClipBookmarkFlushResult>({
    storageKey: "mobileVideoSync.clipBookmark.v1",
    coalesce: (existing, incoming) =>
      clipBookmarkKey(existing) === clipBookmarkKey(incoming) ? incoming : null,
    send: (payload) => trpcVanilla.setClipBookmark.mutate(payload),
    onSuccess: args.onSuccess,
    storage: args.storage,
    shouldCommit: args.shouldCommit,
  });
}
